(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ── Sticky Header ── */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this._lastY = 0;
      window.addEventListener('scroll', this._onScroll.bind(this), { passive: true });
    }
    _onScroll() {
      const y = window.scrollY;
      const header = document.getElementById('SiteHeader');
      const type = this.dataset.type;
      if (!header) return;

      if (y > 80) {
        header.classList.add('site-header--sticky');

        if (type === 'always') {
          header.classList.remove('site-header--hidden');
        } else if (type === 'on-scroll-up') {
          header.classList.toggle('site-header--hidden', y > this._lastY + 5);
        }
      } else {
        header.classList.remove('site-header--sticky', 'site-header--hidden');
      }
      this._lastY = y;
    }
  }
  customElements.define('sticky-header', StickyHeader);

  /* ── Mobile Drawer ── */
  (function () {
    function initMobileDrawer() {
      var toggle = document.getElementById('MobileMenuToggle');
      var close = document.getElementById('MobileMenuClose');
      var overlay = document.getElementById('MobileMenuOverlay');
      var drawer = document.getElementById('MobileMenuDrawer');
      if (!toggle || !drawer) return;

      function openDrawer() {
        drawer.classList.add('mobile-drawer--open');
        drawer.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        drawer.classList.remove('mobile-drawer--open');
        drawer.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      toggle.addEventListener('click', openDrawer);
      if (close) close.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);

      /* Escape key */
      document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });

      /* Accordion sub-menus */
      drawer.querySelectorAll('.mobile-drawer__accordion').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          var sub = btn.nextElementSibling;
          if (sub) sub.style.display = expanded ? 'none' : 'block';
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileDrawer);
    } else {
      initMobileDrawer();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
